
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon120Clock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#000",
  strokeWidth: 4.4,
  cx: 60,
  cy: 60,
  r: 39.8
}), /*#__PURE__*/React.createElement("g", {
  fill: "var(--theme-primary, #810ea9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.977 36.227a2.469 2.469 0 0 1 .905 3.377L62.324 64.735a2.482 2.482 0 0 1-3.386.907 2.469 2.469 0 0 1-.905-3.377l14.558-25.13a2.482 2.482 0 0 1 3.386-.908z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.962 53.977a2.487 2.487 0 0 1 3.39-.91l14.772 8.49a2.468 2.468 0 0 1 .906 3.377 2.487 2.487 0 0 1-3.39.91l-14.772-8.49a2.468 2.468 0 0 1-.906-3.377z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M59.72 26a1.97 1.97 0 0 1 1.97 1.98l-.02 4.038A1.99 1.99 0 0 1 59.68 34a1.97 1.97 0 0 1-1.97-1.98l.02-4.037A1.99 1.99 0 0 1 59.72 26zm0 60a1.97 1.97 0 0 1 1.97 1.98l-.02 4.038A1.99 1.99 0 0 1 59.68 94a1.97 1.97 0 0 1-1.97-1.98l.02-4.037A1.99 1.99 0 0 1 59.72 86zM94 59.72a1.97 1.97 0 0 1-1.98 1.97l-4.038-.02A1.99 1.99 0 0 1 86 59.68a1.97 1.97 0 0 1 1.98-1.97l4.037.02A1.99 1.99 0 0 1 94 59.72zm-60 0a1.97 1.97 0 0 1-1.98 1.97l-4.038-.02A1.99 1.99 0 0 1 26 59.68a1.97 1.97 0 0 1 1.98-1.97l4.037.02A1.99 1.99 0 0 1 34 59.72z",
  fill: "#000"
}))));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <circle stroke=\"#000\" stroke-width=\"4.4\" cx=\"60\" cy=\"60\" r=\"39.8\"/>\r\n        <g fill=\"var(--theme-primary, #810ea9)\">\r\n            <path d=\"M75.977 36.227a2.469 2.469 0 0 1 .905 3.377L62.324 64.735a2.482 2.482 0 0 1-3.386.907 2.469 2.469 0 0 1-.905-3.377l14.558-25.13a2.482 2.482 0 0 1 3.386-.908z\"/>\r\n            <path d=\"M42.962 53.977a2.487 2.487 0 0 1 3.39-.91l14.772 8.49a2.468 2.468 0 0 1 .906 3.377 2.487 2.487 0 0 1-3.39.91l-14.772-8.49a2.468 2.468 0 0 1-.906-3.377z\"/>\r\n        </g>\r\n        <path d=\"M59.72 26a1.97 1.97 0 0 1 1.97 1.98l-.02 4.038A1.99 1.99 0 0 1 59.68 34a1.97 1.97 0 0 1-1.97-1.98l.02-4.037A1.99 1.99 0 0 1 59.72 26zM59.72 86a1.97 1.97 0 0 1 1.97 1.98l-.02 4.038A1.99 1.99 0 0 1 59.68 94a1.97 1.97 0 0 1-1.97-1.98l.02-4.037A1.99 1.99 0 0 1 59.72 86zM94 59.72a1.97 1.97 0 0 1-1.98 1.97l-4.038-.02A1.99 1.99 0 0 1 86 59.68a1.97 1.97 0 0 1 1.98-1.97l4.037.02A1.99 1.99 0 0 1 94 59.72zM34 59.72a1.97 1.97 0 0 1-1.98 1.97l-4.038-.02A1.99 1.99 0 0 1 26 59.68a1.97 1.97 0 0 1 1.98-1.97l4.037.02A1.99 1.99 0 0 1 34 59.72z\" fill=\"#000\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-120-clock.21439fba67295781e8d8a460169ec6f1.svg"),
        {
          React: SvgIcon120Clock,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      